import apiService from '../Api'
import { IOpenedRequests, IRequestConsultants, IRequestList, IRequestTypes } from './types'

export interface IList {
  recordsFiltered: number
  recordsTotal: number
  data: {
    id: number
    tipoDeSolicitacao: string
    consultor_de_sucesso: string
    your_name: string
    nome_responsavel: string
    phone: string
    created_at: string
    status: string
    formato_curso: string
    course: string
  }[]
}

interface IListParams {
  start: number
  length: number
  order: {
    column: number
    dir: string
  }[]
  search: {
    value: string
  }
  created_at: {
    from: string
    to: string
  }
  solved_at: {
    from: string
    to: string
  }
  status: string
  tipo_solicitacao: string
  formato_curso: string
  consultor_de_sucesso: string
}

interface IGetOpenRequestsParams {
  search: {
    value: string
  }
  created_at: {
    from: string
    to: string
  }
  solved_at: {
    from: string
    to: string
  }
  status: string
  tipo_solicitacao: string
  formato_curso: string
  consultor_de_sucesso: string
}

export class RequestService {
  async list(params: IListParams): Promise<IList> {
    const queryParams = new URLSearchParams()
    queryParams.append('start', params.start.toString())
    queryParams.append('length', params.length.toString())
    queryParams.append('order[0][column]', params.order[0].column.toString())
    queryParams.append('order[0][dir]', params.order[0].dir)
    queryParams.append('search[value]', params.search.value)
    queryParams.append('status', params.status)
    queryParams.append('tipo_solicitacao', params.tipo_solicitacao)
    queryParams.append('formato_curso', params.formato_curso)
    queryParams.append('consultor_de_sucesso', params.consultor_de_sucesso)
    queryParams.append('created_at[from]', params.created_at.from)
    queryParams.append('created_at[to]', params.created_at.to)
    queryParams.append('solved_at[from]', params.solved_at.from)
    queryParams.append('solved_at[to]', params.solved_at.to)

    return apiService.get('/requests', { params: queryParams }).then((response) => response.data)
  }

  async get(id: number): Promise<IRequestList> {
    return apiService.get(`/requests/${id}`).then((response) => response.data)
  }

  async getRequestsTypes(): Promise<IRequestTypes> {
    return apiService.get('/requests/types').then((response) => response.data)
  }

  async getRequestsConsultants(): Promise<IRequestConsultants> {
    return apiService.get('/requests/consultants').then((response) => response.data)
  }

  async getOpenRequests(params: IGetOpenRequestsParams): Promise<IOpenedRequests> {
    const queryParams = new URLSearchParams()
    queryParams.append('search[value]', params.search.value)
    queryParams.append('status', params.status)
    queryParams.append('tipo_solicitacao', params.tipo_solicitacao)
    queryParams.append('formato_curso', params.formato_curso)
    queryParams.append('consultor_de_sucesso', params.consultor_de_sucesso)
    queryParams.append('created_at[from]', params.created_at.from)
    queryParams.append('created_at[to]', params.created_at.to)
    queryParams.append('solved_at[from]', params.solved_at.from)
    queryParams.append('solved_at[to]', params.solved_at.to)

    return apiService.get('/requests/get-opened-requests', { params: queryParams }).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async setNewStatus(id: number, status: string): Promise<any> {
    return apiService.put(`/requests/${id}/set-status`, { status }).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async setNewConsultant(id: number, consultant: string): Promise<any> {
    return apiService.put(`/requests/${id}/change-consultant`, { consultant }).then((response) => response.data)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async delete(id: number): Promise<any> {
    return apiService.delete(`/requests/${id}`).then((response) => response.data)
  }
}
